/**
 * Looses the focus of the currently active element, if any
 */
export function loseFocus(): void {
  const activeElement = document.activeElement as HTMLElement | null;

  activeElement?.blur();
}
